import { mixins } from 'sonata-react-components';
import styled from 'styled-components';

export const SearchDropdownStyled = styled.div<{ $addButton?: boolean }>`
  position: relative;

  .searchDropdown {
    &__search {
      align-items: center;
      column-gap: 8px;
      display: flex;

      &Input {
        ${props => (props.$addButton ? 'padding-right: 78px' : '')}
      }

      &Actions {
        display: flex;
        align-items: center;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;

        &Tag {
          margin-right: 16px;
        }
      }
    }

    &__suggestions {
      background-color: ${props => props.theme.uiColors.multiFlightMapSuggestionsBackgroundColor};
      border-radius: 6px;
      border: 1px solid ${props => props.theme.uiColors.multiFlightMapSuggestionsBorderColor};
      left: 0;
      margin-top: 4px;
      max-height: 360px;
      overflow-y: auto;
      padding: 8px;
      position: absolute;
      right: 0;
      top: 100%;
      z-index: 10;
      ${mixins.forceScrollbar}

      &Item {
        align-items: center;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        padding: 8px;

        &:hover {
          background-color: ${props => props.theme.uiColors.multiFlightMapSuggestionsHighlightedColor};
        }
        
        &:last-child {
          margin-bottom: 0;
        }

        &Content {
          display: flex;
          flex-direction: column;
          max-width: 225px;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &Title {
          color: ${props => props.theme.uiColors.multiFlightMapSuggestionsPrimaryColor};
          font-family: ${props => props.theme.fontRegular};
          font-size: ${props => props.theme.fontSizeXS};
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &Subtitle {
          color: ${props => props.theme.uiColors.multiFlightMapSuggestionsSecondaryColor};
          font-family: ${props => props.theme.fontRegular};
          font-size: ${props => props.theme.fontSizeXXS};
          font-weight: 700;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &Container {
            margin-top: 8px;
            display: flex;
            flex-direction: row;
            gap: 8px;
            align-items: center;

            .tag {
              display: flex;
              align-items: center;
              max-width: 155px;
              min-width: 0;

              &__content {
                display: block;
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100%;
              }
            }
          }
        }
      }
    }
  }

  ${props =>
    props.$addButton
      ? `
    .inputSearch__input {
      padding-right: 112px;
    }
  `
      : ''}
`;
